const GOOGLE_API_KEY = "AIzaSyC8v285ZNlJrIQUQ7Ntl04FT8_VB-14VsQ";
const GOOGLE_LOGIN_CLIENT_ID = "858136711155-pmm85jveq0guuh2c9a5flv48ml15g4v6.apps.googleusercontent.com"
const MAP_ID = 'c76512eeb5c9a901267de88f';
const DB_HOST = 'dionysus.headass.house';
const DB_USER = 'researcher';
const DB_PASSWORD = 'researchGeocachingApp!';
const DB_PORT = 3306;
const DB_NAME = 'researchGeocaching';
const BACKEND_URL = 'https://dionysus.headass.house';
const JWT_SECRET = '868ccd21b06745e10c79c8ce4e07b327e39983cb4c4afd2415e2fa8586d8a219';
const CLIENT_AUTH_SECRET = 'e9e21792-152c-40f6-afdc-e13fabc6d3bf';

module.exports = {
    GOOGLE_API_KEY,
    GOOGLE_LOGIN_CLIENT_ID,
    MAP_ID,
    DB_HOST,
    DB_USER,
    DB_PASSWORD,
    DB_PORT,
    DB_NAME,
    BACKEND_URL,
    JWT_SECRET,
    CLIENT_AUTH_SECRET
}